import inlineEditTextfieldDo from "../../../../../../packages/design-system/inline-edit/constellation/index/images/inline-edit-textfield-do.png";
import inlineEditTextfieldDont from "../../../../../../packages/design-system/inline-edit/constellation/index/images/inline-edit-textfield-dont.png";
import * as React from 'react';
export default {
  inlineEditTextfieldDo,
  inlineEditTextfieldDont,
  React
};